<template>
  <div
    class="btn-scroll-to-top"
    :class="{'show': y > 250}"
    :style="{
    top: !is_layout_public ? '12%' : '90%',
    }"
  >
    <!-- We have wrapper because ripple effect give position relative to this absolute positioned btn -->
    <!-- Hence due to that our btn get lost -->
    <b-button
      variant="secondary"
      class="btn-icon"
      @click="scrollToTop"
      size="sm"
    >
    <font-awesome-icon icon="fas fa-angle-up" size="2x"/>
    </b-button>
  </div>
</template>

<script setup>
import {scrollToTop} from '@utils/utils'
import useAuth from '../../utils/useAuth';
import useUtils from '@composables/useUtils';

const { y } = useWindowScroll()

const {
  is_layout_public
} = useUtils();

const {
  is_loggin
} = useAuth();

</script>

<style lang="scss" scoped>

.btn-scroll-to-top {
  position: fixed; 
  right: .5rem;
  z-index: 95;

  opacity: 0;
  // transform: translateY(100px);
  transition: all .5s ease;

  &.show {
      opacity: 1;
      // transform: translateY(0)
  }
}
</style>
